"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const types_1 = require("modules/configManager/types");
class StreamingStore {
    constructor() {
        this.streamingActive = false;
        this.drmProtectionActive = false;
        this.hotmartPlayerActive = false;
        this.setStatus = (status) => {
            (0, mobx_1.extendObservable)(this, status);
        };
    }
    get fileLibraryProvider() {
        return this.hotmartPlayerActive
            ? types_1.FileLibraryProvider.PlayerBackoffice
            : types_1.FileLibraryProvider.Club;
    }
}
__decorate([
    mobx_1.observable
], StreamingStore.prototype, "streamingActive", void 0);
__decorate([
    mobx_1.observable
], StreamingStore.prototype, "drmProtectionActive", void 0);
__decorate([
    mobx_1.observable
], StreamingStore.prototype, "hotmartPlayerActive", void 0);
__decorate([
    mobx_1.computed
], StreamingStore.prototype, "fileLibraryProvider", null);
__decorate([
    mobx_1.action
], StreamingStore.prototype, "setStatus", void 0);
exports.default = new StreamingStore();
